import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pago-vencido',
  templateUrl: './pago-vencido.component.html',
  styleUrls: ['./pago-vencido.component.scss']
})
export class PagoVencidoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
